import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { SimulazioniSrlInputProps } from './DatiSimulazioniSrl';

export default function RiepilogoSimulazioniSrl(props: SimulazioniSrlInputProps) {
    const gClasses = globalStyles();

    const { state } = props;
    let _display1 = props.state.datiSimulazioniSrl.C52 !== undefined && props.state.datiSimulazioniSrl.C52 !== "" ? "table-row" : "none";
    let _display2 = props.state.datiSimulazioniSrl.C53 !== undefined && props.state.datiSimulazioniSrl.C53 !== "" ? "table-row" : "none";
    let _display3 = props.state.datiSimulazioniSrl.C54 !== undefined && props.state.datiSimulazioniSrl.C54 !== "" ? "table-row" : "none";

    return (
        <Paper className={gClasses.fullWidthPaper}>
            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <SectionSubTitle text="1° Simulazione - societa non trasparente - nessun compenso agli amministratori - nessun dividendo"></SectionSubTitle>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Table size="small" padding="none" aria-label="simple table" style={{ fontSize: "10px" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell className={gClasses.tableHeaderFixed} align="left"></TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Compensi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Dividendi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Ires</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr.G.S</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">IRPEF</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Reg.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Com.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Imp. Sost.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr. IVS</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Totale</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="societa">
                                <TableCell component="th" scope="row">
                                    <TextField
                                        name="G48"
                                        label="Società"
                                        value={state.datiSimulazioniSrl.G48}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left"></TableCell>{/*comp*/}
                                <TableCell align="left"></TableCell>{/*div*/}
                                <TableCell align="left">
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="IRES"
                                        value={state.normaleSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>{/*ires*/}
                                <TableCell align="left"></TableCell>{/*contr gs*/}
                                <TableCell align="left"></TableCell>{/*irpef*/}
                                <TableCell align="left"></TableCell>{/*add.reg*/}
                                <TableCell align="left"></TableCell>{/*add.com*/}
                                <TableCell align="left"></TableCell>{/*imp.sost*/}
                                <TableCell align="left"></TableCell>{/*contr.ivs*/}
                                <TableCell align="left">
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="Totale"
                                        value={state.normaleSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>{/*totale*/}
                            </TableRow>
                            <TableRow key="socio1" style={{ display: _display1 }}>
                                <TableCell component="th" scope="row">
                                    <TextField
                                        name="C52"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C52}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                </TableCell>
                                <TableCell align="left">{/*div*/}
                                </TableCell>
                                <TableCell align="left">{/*ires*/}
                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I37"
                                        label="IRPEF"
                                        value={state.normaleSimulazioniSrl.I37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K37"
                                        label="Add. Reg."
                                        value={state.normaleSimulazioniSrl.K37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M37"
                                        label="Add. Com."
                                        value={state.normaleSimulazioniSrl.M37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}
                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H23"
                                        label="Contr. IVS"
                                        value={state.normaleSimulazioniSrl.H23}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N7"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N7}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio2" style={{display: _display2}}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C53"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C53}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                </TableCell>
                                <TableCell align="left">{/*div*/}
                                </TableCell>
                                <TableCell align="left">{/*ires*/}
                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I68"
                                        label="IRPEF"
                                        value={state.normaleSimulazioniSrl.I68}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K68"
                                        label="Add. Reg."
                                        value={state.normaleSimulazioniSrl.K68}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M68"
                                        label="Add. Com."
                                        value={state.normaleSimulazioniSrl.M68}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}

                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H54"
                                        label="Contr. IVS"
                                        value={state.normaleSimulazioniSrl.H54}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N8"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N8}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio3" style={{ display: _display3 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C54"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C54}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}

                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}

                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{margin: "0px"}}
                                        name="I99"
                                        label="IRPEF"
                                        value={state.normaleSimulazioniSrl.I99}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{margin: "0px"}}
                                        name="K99"
                                        label="Add. Reg."
                                        value={state.normaleSimulazioniSrl.K99}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{margin: "0px"}}
                                        name="M99"
                                        label="Add. Com."
                                        value={state.normaleSimulazioniSrl.M99}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}

                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H85"
                                        label="Contr. IVS"
                                        value={state.normaleSimulazioniSrl.H85}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N9"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N9}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="subtotali">
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    Totali
                                </TableCell>
                                <TableCell align="left">{/*comp*/}

                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="Totale IRES"
                                        value={state.normaleSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}

                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H13"
                                        label="Totale IRPEF"
                                        value={state.riepilogoSimulazioniSrl.H13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="Totale Add. Reg."
                                        value={state.riepilogoSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="J13"
                                        label="Totale Add. Com."
                                        value={state.riepilogoSimulazioniSrl.J13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}

                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="L13"
                                        label="Totale Contr. IVS"
                                        value={state.riepilogoSimulazioniSrl.L13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N13"
                                        label="Generale"
                                        value={state.riepilogoSimulazioniSrl.N13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="dicui"> {/*di cui*/}
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">di cui</TableCell>
                                <TableCell align="left"> {/*di cui - imposte*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N14"
                                        label="Imposte"
                                        value={state.riepilogoSimulazioniSrl.N14}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                                <TableCell align="left"> {/*di cui - contributi*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N15"
                                        label="Contributi"
                                        value={state.riepilogoSimulazioniSrl.N15}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <SectionSubTitle text={"2° Simulazione - società non trasparente - compensi " + state.datiSimulazioniSrl.D72 + " - Nessun dividendo"}></SectionSubTitle>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Table size="small" padding="none" aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={gClasses.tableHeaderFixed} align="left"></TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Compensi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Dividendi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Ires</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr.G.S</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">IRPEF</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Reg.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Com.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Imp. Sost.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr. IVS</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Totale</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="societa"> {/*societa*/}
                                <TableCell component="th" scope="row">
                                    <TextField
                                        name="G48"
                                        label="Società"
                                        value={state.datiSimulazioniSrl.G48}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="IRES"
                                        value={state.soloCompSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">
                                    <NumberField style={{ margin: "0px" }}
                                        name="I8"
                                        label="Contr. g.s."
                                        value={state.soloCompSimulazioniSrl.I8}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>{/*contr gs*/}
                                <TableCell align="left">{/*irpef*/}</TableCell>
                                <TableCell align="left">{/*add.reg*/}</TableCell>
                                <TableCell align="left">{/*add.com*/}</TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}</TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N21"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N21}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio1" style={{ display: _display1 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C52"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C52}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G74"
                                        label="Comp."
                                        value={state.datiSimulazioniSrl.G74}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="D25"
                                        label="Contr. g.s."
                                        value={state.soloCompSimulazioniSrl.D25}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I36"
                                        label="IRPEF"
                                        value={state.soloCompSimulazioniSrl.I36}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K36"
                                        label="Add. reg."
                                        value={state.soloCompSimulazioniSrl.K36}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M36"
                                        label="Add. com."
                                        value={state.soloCompSimulazioniSrl.M36}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}

                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H22"
                                        label="Contr. ivs"
                                        value={state.soloCompSimulazioniSrl.H22}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N22"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N22}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio2" style={{ display: _display2 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C53"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C53}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G75"
                                        label="Comp."
                                        value={state.datiSimulazioniSrl.G75}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="D56"
                                        label="Contr. g.s."
                                        value={state.soloCompSimulazioniSrl.D56}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I67"
                                        label="IRPEF"
                                        value={state.soloCompSimulazioniSrl.I67}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K67"
                                        label="Add. reg."
                                        value={state.soloCompSimulazioniSrl.K67}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M67"
                                        label="Add. com."
                                        value={state.soloCompSimulazioniSrl.M67}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}

                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H53"
                                        label="Contr. ivs"
                                        value={state.soloCompSimulazioniSrl.H53}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N23"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N23}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio3" style={{ display: _display3 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C54"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C54}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G76"
                                        label="Comp."
                                        value={state.datiSimulazioniSrl.G76}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="D87"
                                        label="Contr. g.s."
                                        value={state.soloCompSimulazioniSrl.D87}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I98"
                                        label="IRPEF"
                                        value={state.soloCompSimulazioniSrl.I98}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K98"
                                        label="Add. reg."
                                        value={state.soloCompSimulazioniSrl.K98}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M98"
                                        label="Add. com."
                                        value={state.soloCompSimulazioniSrl.M98}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}

                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H84"
                                        label="Contr. ivs"
                                        value={state.soloCompSimulazioniSrl.H84}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N24"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N24}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="subtotali">
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    Totali
                                </TableCell>
                                <TableCell align="left">{/*comp*/}

                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="Totale IRES"
                                        value={state.soloCompSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G28"
                                        label="Totale Contr. g.s."
                                        value={state.riepilogoSimulazioniSrl.G28}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H28"
                                        label="Totale IRPEF"
                                        value={state.riepilogoSimulazioniSrl.H28}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I28"
                                        label="Totale Add. Reg."
                                        value={state.riepilogoSimulazioniSrl.I28}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="J28"
                                        label="Totale Add. Com."
                                        value={state.riepilogoSimulazioniSrl.J28}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}

                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="L28"
                                        label="Totale Contr. IVS"
                                        value={state.riepilogoSimulazioniSrl.L28}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N28"
                                        label="Generale"
                                        value={state.riepilogoSimulazioniSrl.N28}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="dicui"> {/*di cui*/}
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">di cui</TableCell>
                                <TableCell align="left"> {/*di cui - imposte*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N29"
                                        label="Imposte"
                                        value={state.riepilogoSimulazioniSrl.N29}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                                <TableCell align="left"> {/*di cui - contributi*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N30"
                                        label="Contributi"
                                        value={state.riepilogoSimulazioniSrl.N30}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>

                            </TableRow>

                        </TableBody>
                    </Table>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <SectionSubTitle text={"3° Simulazione - società non trasparente - no compensi - distribuzione dividendi " + state.datiSimulazioniSrl.D83}></SectionSubTitle>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Table size="small" padding="none" aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={gClasses.tableHeaderFixed} align="left"></TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Compensi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Dividendi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Ires</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr.G.S</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">IRPEF</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Reg.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Com.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Imp. Sost.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr. IVS</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Totale</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="societa"> {/*societa*/}
                                <TableCell component="th" scope="row">
                                    <TextField
                                        name="G48"
                                        label="Società"
                                        value={state.datiSimulazioniSrl.G48}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="IRES"
                                        value={state.soloDivSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}</TableCell>
                                <TableCell align="left">{/*irpef*/}</TableCell>
                                <TableCell align="left">{/*add.reg*/}</TableCell>
                                <TableCell align="left">{/*add.com*/}</TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}</TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="Totale"
                                        value={state.soloDivSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio1" style={{ display: _display1 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C52"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C52}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M25"
                                        label="Divid."
                                        value={state.soloDivSimulazioniSrl.M25}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}</TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I37"
                                        label="IRPEF"
                                        value={state.soloDivSimulazioniSrl.I37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K37"
                                        label="Add. reg."
                                        value={state.soloDivSimulazioniSrl.K37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M37"
                                        label="Add. com."
                                        value={state.soloDivSimulazioniSrl.M37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M33"
                                        label="Imp. sost."
                                        value={state.soloDivSimulazioniSrl.M33}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H23"
                                        label="Contr. ivs"
                                        value={state.soloDivSimulazioniSrl.H23}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N38"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N38}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio2" style={{ display: _display2 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C53"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C53}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M56"
                                        label="Divid."
                                        value={state.soloDivSimulazioniSrl.M56}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}</TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I68"
                                        label="IRPEF"
                                        value={state.soloDivSimulazioniSrl.I68}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K68"
                                        label="Add. reg."
                                        value={state.soloDivSimulazioniSrl.K68}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M68"
                                        label="Add. com."
                                        value={state.soloDivSimulazioniSrl.M68}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M64"
                                        label="Imp. sost."
                                        value={state.soloDivSimulazioniSrl.M64}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H54"
                                        label="Contr. ivs"
                                        value={state.soloDivSimulazioniSrl.H54}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N38"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N39}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio3" style={{ display: _display3 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C54"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C54}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M87"
                                        label="Divid."
                                        value={state.soloDivSimulazioniSrl.M87}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}</TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I99"
                                        label="IRPEF"
                                        value={state.soloDivSimulazioniSrl.I99}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K99"
                                        label="Add. reg."
                                        value={state.soloDivSimulazioniSrl.K99}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M99"
                                        label="Add. com."
                                        value={state.soloDivSimulazioniSrl.M99}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M64"
                                        label="Imp. sost."
                                        value={state.soloDivSimulazioniSrl.M95}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H54"
                                        label="Contr. ivs"
                                        value={state.soloDivSimulazioniSrl.H85}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N38"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N40}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="subtotali">
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    Totali
                                </TableCell>
                                <TableCell align="left">{/*comp*/}

                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="Totale IRES"
                                        value={state.soloDivSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}</TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H44"
                                        label="Totale IRPEF"
                                        value={state.riepilogoSimulazioniSrl.H44}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I44"
                                        label="Totale Add. Reg."
                                        value={state.riepilogoSimulazioniSrl.I44}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="J44"
                                        label="Totale Add. Com."
                                        value={state.riepilogoSimulazioniSrl.J44}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K44"
                                        label="Totale Imp. sost."
                                        value={state.riepilogoSimulazioniSrl.K44}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="L44"
                                        label="Totale Contr. IVS"
                                        value={state.riepilogoSimulazioniSrl.L44}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N44"
                                        label="Generale"
                                        value={state.riepilogoSimulazioniSrl.N44}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="dicui"> {/*di cui*/}
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">
                                    di cui
                            </TableCell>
                                <TableCell align="left"> {/*di cui - imposte*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N45"
                                        label="Imposte"
                                        value={state.riepilogoSimulazioniSrl.N45}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                                <TableCell align="left"> {/*di cui - contributi*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N46"
                                        label="Contributi"
                                        value={state.riepilogoSimulazioniSrl.N46}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>

                            </TableRow>
                        </TableBody>
                    </Table>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <SectionSubTitle text={"4° Simulazione - società non trasparente - compensi " + state.datiSimulazioniSrl.D89 + " - Distribuzione dividendi " + state.datiSimulazioniSrl.D88}></SectionSubTitle>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Table size="small" padding="none" aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={gClasses.tableHeaderFixed} align="left"></TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Compensi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Dividendi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Ires</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr.G.S</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">IRPEF</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Reg.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Com.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Imp. Sost.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr. IVS</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Totale</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="societa"> {/*societa*/}
                                <TableCell component="th" scope="row">
                                    <TextField
                                        name="G48"
                                        label="Società"
                                        value={state.datiSimulazioniSrl.G48}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="IRES"
                                        value={state.compDivSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I8"
                                        label="Contr. g.s."
                                        value={state.compDivSimulazioniSrl.I8}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    /></TableCell>
                                <TableCell align="left">{/*irpef*/}</TableCell>
                                <TableCell align="left">{/*add.reg*/}</TableCell>
                                <TableCell align="left">{/*add.com*/}</TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}</TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N54"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N54}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio1" style={{ display: _display1 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C52"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C52}
                                        className={gClasses.textFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G91"
                                        label="Comp."
                                        value={state.datiSimulazioniSrl.G91}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    /></TableCell>
                                <TableCell align="left">{/*div*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M25"
                                        label="Divid."
                                        value={state.compDivSimulazioniSrl.M25}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="D26"
                                        label="Contr. g.s."
                                        value={state.compDivSimulazioniSrl.D26}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    /></TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I37"
                                        label="IRPEF"
                                        value={state.compDivSimulazioniSrl.I37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K37"
                                        label="Add. reg."
                                        value={state.compDivSimulazioniSrl.K37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M37"
                                        label="Add. com."
                                        value={state.compDivSimulazioniSrl.M37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M33"
                                        label="Imp. sost."
                                        value={state.compDivSimulazioniSrl.M33}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H23"
                                        label="Contr. ivs"
                                        value={state.compDivSimulazioniSrl.H23}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N55"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N55}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio2" style={{ display: _display2 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C53"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C53}
                                        className={gClasses.textFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G92"
                                        label="Comp."
                                        value={state.datiSimulazioniSrl.G92}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    /></TableCell>
                                <TableCell align="left">{/*div*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M56"
                                        label="Divid."
                                        value={state.compDivSimulazioniSrl.M56}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="D57"
                                        label="Contr. g.s."
                                        value={state.compDivSimulazioniSrl.D57}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    /></TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I68"
                                        label="IRPEF"
                                        value={state.compDivSimulazioniSrl.I68}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K68"
                                        label="Add. reg."
                                        value={state.compDivSimulazioniSrl.K68}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M68"
                                        label="Add. com."
                                        value={state.compDivSimulazioniSrl.M68}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M64"
                                        label="Imp. sost."
                                        value={state.compDivSimulazioniSrl.M64}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H54"
                                        label="Contr. ivs"
                                        value={state.compDivSimulazioniSrl.H54}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N56"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N56}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio3" style={{ display: _display3 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C54"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C54}
                                        className={gClasses.textFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G93"
                                        label="Comp."
                                        value={state.datiSimulazioniSrl.G93}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    /></TableCell>
                                <TableCell align="left">{/*div*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M87"
                                        label="Divid."
                                        value={state.compDivSimulazioniSrl.M87}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="D88"
                                        label="Contr. g.s."
                                        value={state.compDivSimulazioniSrl.D88}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    /></TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I99"
                                        label="IRPEF"
                                        value={state.compDivSimulazioniSrl.I99}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K99"
                                        label="Add. reg."
                                        value={state.compDivSimulazioniSrl.K99}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M99"
                                        label="Add. com."
                                        value={state.compDivSimulazioniSrl.M99}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M95"
                                        label="Imp. sost."
                                        value={state.compDivSimulazioniSrl.M95}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H85"
                                        label="Contr. ivs"
                                        value={state.compDivSimulazioniSrl.H85}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N57"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N57}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="subtotali">
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    Totali
                                </TableCell>
                                <TableCell align="left">{/*comp*/}

                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I13"
                                        label="Totale IRES"
                                        value={state.compDivSimulazioniSrl.I13}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G61"
                                        label="Totale Contr. g.s."
                                        value={state.riepilogoSimulazioniSrl.G61}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    /></TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H61"
                                        label="Totale IRPEF"
                                        value={state.riepilogoSimulazioniSrl.H61}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I61"
                                        label="Totale Add. reg."
                                        value={state.riepilogoSimulazioniSrl.I61}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="J61"
                                        label="Totale Add. com."
                                        value={state.riepilogoSimulazioniSrl.J61}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K61"
                                        label="Totale Imp. sost."
                                        value={state.riepilogoSimulazioniSrl.K61}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="L61"
                                        label="Totale Contr. ivs"
                                        value={state.riepilogoSimulazioniSrl.L61}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N61"
                                        label="Generale"
                                        value={state.riepilogoSimulazioniSrl.N61}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="dicui"> {/*di cui*/}
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">
                                    di cui
                            </TableCell>
                                <TableCell align="left"> {/*di cui - imposte*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N62"
                                        label="Imposte"
                                        value={state.riepilogoSimulazioniSrl.N62}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                                <TableCell align="left"> {/*di cui - contributi*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N63"
                                        label="Contributi"
                                        value={state.riepilogoSimulazioniSrl.N63}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>

                            </TableRow>
                        </TableBody>
                    </Table>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <SectionSubTitle text="5° Simulazione - società trasparente - nessun compenso agli amministratori"></SectionSubTitle>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Table size="small" padding="none" aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={gClasses.tableHeaderFixed} style={{minWidth: '310px !important' }} align="left"></TableCell>  {/*FIX*/}
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Compensi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Dividendi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Ires</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr.G.S</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">IRPEF</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Reg.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Com.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Imp. Sost.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr. IVS</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Totale</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="socio1" style={{ display: _display1 }}> {/*societa*/}
                                <TableCell component="th" scope="row">
                                    <TextField
                                        name="C52"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C52}
                                        className={gClasses.textFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}</TableCell>
                                <TableCell align="left">{/*contr gs*/}</TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I37"
                                        label="IRPEF"
                                        value={state.traspSimulazioniSrl.I37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K37"
                                        label="Add. Reg."
                                        value={state.traspSimulazioniSrl.K37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M37"
                                        label="Add. Com."
                                        value={state.traspSimulazioniSrl.M37}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H23"
                                        label="Contr. ivs"
                                        value={state.traspSimulazioniSrl.H23}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N71"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N71}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio2" style={{ display: _display2 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C53"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C53}
                                        className={gClasses.textFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}</TableCell>
                                <TableCell align="left">{/*contr gs*/}</TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I69"
                                        label="IRPEF"
                                        value={state.traspSimulazioniSrl.I69}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K69"
                                        label="Add. Reg."
                                        value={state.traspSimulazioniSrl.K69}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M69"
                                        label="Add. Com."
                                        value={state.traspSimulazioniSrl.M69}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H55"
                                        label="Contr. ivs"
                                        value={state.traspSimulazioniSrl.H55}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N72"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N72}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio3" style={{ display: _display3 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C54"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C54}
                                        className={gClasses.textFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}</TableCell>
                                <TableCell align="left">{/*contr gs*/}</TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I100"
                                        label="IRPEF"
                                        value={state.traspSimulazioniSrl.I100}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K100"
                                        label="Add. Reg."
                                        value={state.traspSimulazioniSrl.K100}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M100"
                                        label="Add. Com."
                                        value={state.traspSimulazioniSrl.M100}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H86"
                                        label="Contr. ivs"
                                        value={state.traspSimulazioniSrl.H86}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N73"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N73}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="subtotali">
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    Totali
                                </TableCell>
                                <TableCell align="left">{/*comp*/}

                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}</TableCell>
                                <TableCell align="left">{/*contr gs*/}</TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H77"
                                        label="Totale IRPEF"
                                        value={state.riepilogoSimulazioniSrl.H77}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I77"
                                        label="Totale Add. reg."
                                        value={state.riepilogoSimulazioniSrl.I77}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="J77"
                                        label="Totale Add. com."
                                        value={state.riepilogoSimulazioniSrl.J77}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="L77"
                                        label="Totale Contr. ivs"
                                        value={state.riepilogoSimulazioniSrl.L77}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N77"
                                        label="Generale"
                                        value={state.riepilogoSimulazioniSrl.N77}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="dicui"> {/*di cui*/}
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">
                                    di cui
                            </TableCell>
                                <TableCell align="left"> {/*di cui - imposte*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N78"
                                        label="Imposte"
                                        value={state.riepilogoSimulazioniSrl.N78}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                                <TableCell align="left"> {/*di cui - contributi*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N79"
                                        label="Contributi"
                                        value={state.riepilogoSimulazioniSrl.N79}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>

                            </TableRow>
                        </TableBody>
                    </Table>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <SectionSubTitle text={"6° Simulazione - società trasparente - compensi " + state.datiSimulazioniSrl.D102}></SectionSubTitle>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Table size="small" padding="none" aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={gClasses.tableHeaderFixed} align="left"></TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Compensi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Dividendi</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Ires</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr.G.S</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">IRPEF</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Reg.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Add. Com.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Imp. Sost.</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Contr. IVS</TableCell>
                                <TableCell className={gClasses.tableHeaderFixed} align="left">Totale</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="societa"> {/*societa*/}
                                <TableCell component="th" scope="row">
                                    <TextField
                                        name="G48"
                                        label="Società"
                                        value={state.datiSimulazioniSrl.G48}
                                        className={gClasses.longTextFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}</TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}</TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I8"
                                        label="Contr. g.s."
                                        value={state.traspCompSimulazioniSrl.I8}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}</TableCell>
                                <TableCell align="left">{/*add.reg*/}</TableCell>
                                <TableCell align="left">{/*add.com*/}</TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}</TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I8"
                                        label="Totale"
                                        value={state.traspCompSimulazioniSrl.I8}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio1" style={{ display: _display1 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C52"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C52}
                                        className={gClasses.textFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G104"
                                        label="Comp."
                                        value={state.datiSimulazioniSrl.G104}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}</TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="D25"
                                        label="Contr. g.s."
                                        value={state.traspCompSimulazioniSrl.D25}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I36"
                                        label="IRPEF"
                                        value={state.traspCompSimulazioniSrl.I36}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K36"
                                        label="Add. Reg."
                                        value={state.traspCompSimulazioniSrl.K36}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M36"
                                        label="Add. Com."
                                        value={state.traspCompSimulazioniSrl.M36}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H22"
                                        label="Contr. IVS"
                                        value={state.traspCompSimulazioniSrl.H22}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N87"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N87}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio2" style={{ display: _display2 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C53"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C53}
                                        className={gClasses.textFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G105"
                                        label="Comp."
                                        value={state.datiSimulazioniSrl.G105}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}</TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="D56"
                                        label="Contr. g.s."
                                        value={state.traspCompSimulazioniSrl.D56}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I67"
                                        label="IRPEF"
                                        value={state.traspCompSimulazioniSrl.I67}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K67"
                                        label="Add. Reg."
                                        value={state.traspCompSimulazioniSrl.K67}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M36"
                                        label="Add. Com."
                                        value={state.traspCompSimulazioniSrl.M67}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H53"
                                        label="Contr. IVS"
                                        value={state.traspCompSimulazioniSrl.H53}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N88"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N88}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="socio3" style={{ display: _display3 }}>
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    <TextField
                                        name="C54"
                                        label="Socio"
                                        value={state.datiSimulazioniSrl.C54}
                                        className={gClasses.textFieldReadOnly}
                                        InputLabelProps={{
                                            shrink: true,
                                            disabled: true
                                        }}
                                        inputProps={{tabIndex: -1}}
                                        margin="normal"
                                    />
                                </TableCell>
                                <TableCell align="left">{/*comp*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G106"
                                        label="Comp."
                                        value={state.datiSimulazioniSrl.G106}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*div*/}</TableCell>
                                <TableCell align="left">{/*ires*/}</TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="D87"
                                        label="Contr. g.s."
                                        value={state.traspCompSimulazioniSrl.D87}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I98"
                                        label="IRPEF"
                                        value={state.traspCompSimulazioniSrl.I98}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="K98"
                                        label="Add. Reg."
                                        value={state.traspCompSimulazioniSrl.K98}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="M36"
                                        label="Add. Com."
                                        value={state.traspCompSimulazioniSrl.M98}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}</TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H53"
                                        label="Contr. IVS"
                                        value={state.traspCompSimulazioniSrl.H84}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N89"
                                        label="Totale"
                                        value={state.riepilogoSimulazioniSrl.N89}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="subtotali">
                                <TableCell component="th" scope="row"> {/*societa*/}
                                    Totali
                                </TableCell>
                                <TableCell align="left">{/*comp*/}

                                </TableCell>
                                <TableCell align="left">{/*div*/}

                                </TableCell>
                                <TableCell align="left">{/*ires*/}

                                </TableCell>
                                <TableCell align="left">{/*contr gs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="G93"
                                        label="Totale Contr. g.s."
                                        value={state.riepilogoSimulazioniSrl.G93}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*irpef*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="H93"
                                        label="Totale IRPEF"
                                        value={state.riepilogoSimulazioniSrl.H93}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.reg*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="I93"
                                        label="Totale Add. Reg."
                                        value={state.riepilogoSimulazioniSrl.I93}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*add.com*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="J93"
                                        label="Totale Add. Com."
                                        value={state.riepilogoSimulazioniSrl.J93}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*imp.sost*/}

                                </TableCell>
                                <TableCell align="left">{/*contr.ivs*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="L93"
                                        label="Totale Contr. IVS"
                                        value={state.riepilogoSimulazioniSrl.L93}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                    />
                                </TableCell>
                                <TableCell align="left">{/*totale*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N93"
                                        label="Generale"
                                        value={state.riepilogoSimulazioniSrl.N93}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow key="dicui"> {/*di cui*/}
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">
                                    di cui
                            </TableCell>
                                <TableCell align="left"> {/*di cui - imposte*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N94"
                                        label="Imposte"
                                        value={state.riepilogoSimulazioniSrl.N94}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>
                                <TableCell align="left"> {/*di cui - contributi*/}
                                    <NumberField style={{ margin: "0px" }}
                                        name="N95"
                                        label="Contributi"
                                        value={state.riepilogoSimulazioniSrl.N95}
                                        className={gClasses.textFieldReadOnly}
                                        readOnly={true}
                                        special={true}
                                    />
                                </TableCell>

                            </TableRow>
                        </TableBody>
                    </Table>
                </ExpansionPanelDetails>
            </ExpansionPanel>

        </Paper>
    );
}

/*
function RiepilogoSimulazioniSrl_OLD(props: SimulazioniSrlInputProps) {
    const classes = useStyles();
    const gClasses = globalStyles();

    const { state } = props;

    return (
        <React.Fragment>
            <SectionTitle primary={false} text="1° Simulazione - società non trasparente - nessun compenso agli amministratori - nessun dividendo"></SectionTitle>
            <Paper className={gClasses.mainPaper}>
                <div>
                    <TextField
                        name="G48"
                        label="Società"
                        value={state.datiSimulazioniSrl.G48}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="IRES"
                        value={state.normaleSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="Totale"
                        value={state.normaleSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C52"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C52}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I37"
                        label="IRPEF"
                        value={state.normaleSimulazioniSrl.I37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K37"
                        label="Add. Reg."
                        value={state.normaleSimulazioniSrl.K37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M37"
                        label="Add. Com."
                        value={state.normaleSimulazioniSrl.M37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H23"
                        label="Contr. IVS"
                        value={state.normaleSimulazioniSrl.H23}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N7"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N7}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C53"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C53}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I68"
                        label="IRPEF"
                        value={state.normaleSimulazioniSrl.I68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K68"
                        label="Add. Reg."
                        value={state.normaleSimulazioniSrl.K68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M68"
                        label="Add. Com."
                        value={state.normaleSimulazioniSrl.M68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H54"
                        label="Contr. IVS"
                        value={state.normaleSimulazioniSrl.H54}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N8"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N8}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C54"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C54}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I99"
                        label="IRPEF"
                        value={state.normaleSimulazioniSrl.I99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K99"
                        label="Add. Reg."
                        value={state.normaleSimulazioniSrl.K99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M99"
                        label="Add. Com."
                        value={state.normaleSimulazioniSrl.M99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H85"
                        label="Contr. IVS"
                        value={state.normaleSimulazioniSrl.H85}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N9"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N9}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="Totale IRES"
                        value={state.normaleSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H13"
                        label="Totale IRPEF"
                        value={state.riepilogoSimulazioniSrl.H13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="Totale Add. Reg."
                        value={state.riepilogoSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="J13"
                        label="Totale Add. Com."
                        value={state.riepilogoSimulazioniSrl.J13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="L13"
                        label="Totale Contr. IVS"
                        value={state.riepilogoSimulazioniSrl.L13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="N13"
                        label="Generale"
                        value={state.riepilogoSimulazioniSrl.N13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N14"
                        label="Imposte"
                        value={state.riepilogoSimulazioniSrl.N14}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N15"
                        label="Contributi"
                        value={state.riepilogoSimulazioniSrl.N15}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </Paper>
            <SectionTitle primary={false} text={"2° Simulazione - società non trasparente - compensi " + state.datiSimulazioniSrl.D72 + " - Nessun dividendo"}></SectionTitle>
            <Paper className={gClasses.mainPaper}>
                <div>
                    <TextField
                        name="G48"
                        label="Società"
                        value={state.datiSimulazioniSrl.G48}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="IRES"
                        value={state.soloCompSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I8"
                        label="Contr. g.s."
                        value={state.soloCompSimulazioniSrl.I8}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N21"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N21}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C52"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C52}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G74"
                        label="Comp."
                        value={state.datiSimulazioniSrl.G74}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="D25"
                        label="Contr. g.s."
                        value={state.soloCompSimulazioniSrl.D25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I36"
                        label="IRPEF"
                        value={state.soloCompSimulazioniSrl.I36}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K36"
                        label="Add. reg."
                        value={state.soloCompSimulazioniSrl.K36}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M36"
                        label="Add. com."
                        value={state.soloCompSimulazioniSrl.M36}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H22"
                        label="Contr. ivs"
                        value={state.soloCompSimulazioniSrl.H22}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N22"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N22}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C53"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C53}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G75"
                        label="Comp."
                        value={state.datiSimulazioniSrl.G75}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="D56"
                        label="Contr. g.s."
                        value={state.soloCompSimulazioniSrl.D56}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I67"
                        label="IRPEF"
                        value={state.soloCompSimulazioniSrl.I67}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K67"
                        label="Add. reg."
                        value={state.soloCompSimulazioniSrl.K67}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M67"
                        label="Add. com."
                        value={state.soloCompSimulazioniSrl.M67}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H53"
                        label="Contr. ivs"
                        value={state.soloCompSimulazioniSrl.H53}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N23"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N23}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C54"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C54}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G76"
                        label="Comp."
                        value={state.datiSimulazioniSrl.G76}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="D87"
                        label="Contr. g.s."
                        value={state.soloCompSimulazioniSrl.D87}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I98"
                        label="IRPEF"
                        value={state.soloCompSimulazioniSrl.I98}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K98"
                        label="Add. reg."
                        value={state.soloCompSimulazioniSrl.K98}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M98"
                        label="Add. com."
                        value={state.soloCompSimulazioniSrl.M98}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H84"
                        label="Contr. ivs"
                        value={state.soloCompSimulazioniSrl.H84}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N24"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N24}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="Totale IRES"
                        value={state.soloCompSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G28"
                        label="Totale Contr. g.s."
                        value={state.riepilogoSimulazioniSrl.G28}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H28"
                        label="Totale IRPEF"
                        value={state.riepilogoSimulazioniSrl.H28}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I28"
                        label="Totale Add. Reg."
                        value={state.riepilogoSimulazioniSrl.I28}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="J28"
                        label="Totale Add. Com."
                        value={state.riepilogoSimulazioniSrl.J28}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="L28"
                        label="Totale Contr. IVS"
                        value={state.riepilogoSimulazioniSrl.L28}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="N28"
                        label="Generale"
                        value={state.riepilogoSimulazioniSrl.N28}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N29"
                        label="Imposte"
                        value={state.riepilogoSimulazioniSrl.N29}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N30"
                        label="Contributi"
                        value={state.riepilogoSimulazioniSrl.N30}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </Paper>
            <SectionTitle primary={false} text={"3° Simulazione - società non trasparente - no compensi - distribuzione dividendi " + state.datiSimulazioniSrl.D83}></SectionTitle>
            <Paper className={gClasses.mainPaper}>
                <div>
                    <TextField
                        name="G48"
                        label="Società"
                        value={state.datiSimulazioniSrl.G48}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="IRES"
                        value={state.soloDivSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="Totale"
                        value={state.soloDivSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C52"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C52}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M25"
                        label="Divid."
                        value={state.soloDivSimulazioniSrl.M25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I37"
                        label="IRPEF"
                        value={state.soloDivSimulazioniSrl.I37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K37"
                        label="Add. reg."
                        value={state.soloDivSimulazioniSrl.K37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M37"
                        label="Add. com."
                        value={state.soloDivSimulazioniSrl.M37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M33"
                        label="Imp. sost."
                        value={state.soloDivSimulazioniSrl.M33}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H23"
                        label="Contr. ivs"
                        value={state.soloDivSimulazioniSrl.H23}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N38"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N38}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C53"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C53}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M56"
                        label="Divid."
                        value={state.soloDivSimulazioniSrl.M56}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I68"
                        label="IRPEF"
                        value={state.soloDivSimulazioniSrl.I68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K68"
                        label="Add. reg."
                        value={state.soloDivSimulazioniSrl.K68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M68"
                        label="Add. com."
                        value={state.soloDivSimulazioniSrl.M68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M64"
                        label="Imp. sost."
                        value={state.soloDivSimulazioniSrl.M64}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H54"
                        label="Contr. ivs"
                        value={state.soloDivSimulazioniSrl.H54}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N38"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N39}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C54"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C54}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M87"
                        label="Divid."
                        value={state.soloDivSimulazioniSrl.M87}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I99"
                        label="IRPEF"
                        value={state.soloDivSimulazioniSrl.I99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K99"
                        label="Add. reg."
                        value={state.soloDivSimulazioniSrl.K99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M99"
                        label="Add. com."
                        value={state.soloDivSimulazioniSrl.M99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M64"
                        label="Imp. sost."
                        value={state.soloDivSimulazioniSrl.M95}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H54"
                        label="Contr. ivs"
                        value={state.soloDivSimulazioniSrl.H85}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N38"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N40}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="Totale IRES"
                        value={state.soloDivSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H44"
                        label="Totale IRPEF"
                        value={state.riepilogoSimulazioniSrl.H44}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I44"
                        label="Totale Add. Reg."
                        value={state.riepilogoSimulazioniSrl.I44}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="J44"
                        label="Totale Add. Com."
                        value={state.riepilogoSimulazioniSrl.J44}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K44"
                        label="Totale Imp. sost."
                        value={state.riepilogoSimulazioniSrl.K44}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="L44"
                        label="Totale Contr. IVS"
                        value={state.riepilogoSimulazioniSrl.L44}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="N44"
                        label="Generale"
                        value={state.riepilogoSimulazioniSrl.N44}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N45"
                        label="Imposte"
                        value={state.riepilogoSimulazioniSrl.N45}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N46"
                        label="Contributi"
                        value={state.riepilogoSimulazioniSrl.N46}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </Paper>
            <SectionTitle primary={false} text={"4° Simulazione - società non trasparente - compensi " + state.datiSimulazioniSrl.D89 + " - Distribuzione dividendi " + state.datiSimulazioniSrl.D88}></SectionTitle>
            <Paper className={gClasses.mainPaper}>
                <div>
                    <TextField
                        name="G48"
                        label="Società"
                        value={state.datiSimulazioniSrl.G48}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="IRES"
                        value={state.compDivSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I8"
                        label="Contr. g.s."
                        value={state.compDivSimulazioniSrl.I8}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N54"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N54}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C52"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C52}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G91"
                        label="Comp."
                        value={state.datiSimulazioniSrl.G91}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M25"
                        label="Divid."
                        value={state.compDivSimulazioniSrl.M25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="D26"
                        label="Contr. g.s."
                        value={state.compDivSimulazioniSrl.D26}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I37"
                        label="IRPEF"
                        value={state.compDivSimulazioniSrl.I37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K37"
                        label="Add. reg."
                        value={state.compDivSimulazioniSrl.K37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M37"
                        label="Add. com."
                        value={state.compDivSimulazioniSrl.M37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M33"
                        label="Imp. sost."
                        value={state.compDivSimulazioniSrl.M33}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H23"
                        label="Contr. ivs"
                        value={state.compDivSimulazioniSrl.H23}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N55"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N55}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C53"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C53}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G92"
                        label="Comp."
                        value={state.datiSimulazioniSrl.G92}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M56"
                        label="Divid."
                        value={state.compDivSimulazioniSrl.M56}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="D57"
                        label="Contr. g.s."
                        value={state.compDivSimulazioniSrl.D57}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I68"
                        label="IRPEF"
                        value={state.compDivSimulazioniSrl.I68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K68"
                        label="Add. reg."
                        value={state.compDivSimulazioniSrl.K68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M68"
                        label="Add. com."
                        value={state.compDivSimulazioniSrl.M68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M64"
                        label="Imp. sost."
                        value={state.compDivSimulazioniSrl.M64}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H54"
                        label="Contr. ivs"
                        value={state.compDivSimulazioniSrl.H54}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N56"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N56}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C54"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C54}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G93"
                        label="Comp."
                        value={state.datiSimulazioniSrl.G93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M87"
                        label="Divid."
                        value={state.compDivSimulazioniSrl.M87}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="D88"
                        label="Contr. g.s."
                        value={state.compDivSimulazioniSrl.D88}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I99"
                        label="IRPEF"
                        value={state.compDivSimulazioniSrl.I99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K99"
                        label="Add. reg."
                        value={state.compDivSimulazioniSrl.K99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M99"
                        label="Add. com."
                        value={state.compDivSimulazioniSrl.M99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M95"
                        label="Imp. sost."
                        value={state.compDivSimulazioniSrl.M95}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H85"
                        label="Contr. ivs"
                        value={state.compDivSimulazioniSrl.H85}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N57"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N57}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="I13"
                        label="Totale IRES"
                        value={state.compDivSimulazioniSrl.I13}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G61"
                        label="Totale Contr. g.s."
                        value={state.riepilogoSimulazioniSrl.G61}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H61"
                        label="Totale IRPEF"
                        value={state.riepilogoSimulazioniSrl.H61}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I61"
                        label="Totale Add. reg."
                        value={state.riepilogoSimulazioniSrl.I61}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="J61"
                        label="Totale Add. com."
                        value={state.riepilogoSimulazioniSrl.J61}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K61"
                        label="Totale Imp. sost."
                        value={state.riepilogoSimulazioniSrl.K61}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="L61"
                        label="Totale Contr. ivs"
                        value={state.riepilogoSimulazioniSrl.L61}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="N61"
                        label="Generale"
                        value={state.riepilogoSimulazioniSrl.N61}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N62"
                        label="Imposte"
                        value={state.riepilogoSimulazioniSrl.N62}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N63"
                        label="Contributi"
                        value={state.riepilogoSimulazioniSrl.N63}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </Paper>
            <SectionTitle primary={false} text="5° Simulazione - società trasparente - nessun compenso agli amministratori"></SectionTitle>
            <Paper className={gClasses.mainPaper}>
                <div>
                    <TextField
                        name="C52"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C52}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I37"
                        label="IRPEF"
                        value={state.traspSimulazioniSrl.I37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K37"
                        label="Add. Reg."
                        value={state.traspSimulazioniSrl.K37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M37"
                        label="Add. Com."
                        value={state.traspSimulazioniSrl.M37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H23"
                        label="Contr. ivs"
                        value={state.traspSimulazioniSrl.H23}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N71"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N71}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C53"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C53}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I69"
                        label="IRPEF"
                        value={state.traspSimulazioniSrl.I69}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K69"
                        label="Add. Reg."
                        value={state.traspSimulazioniSrl.K69}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M69"
                        label="Add. Com."
                        value={state.traspSimulazioniSrl.M69}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H55"
                        label="Contr. ivs"
                        value={state.traspSimulazioniSrl.H55}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N72"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N72}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C54"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C54}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I100"
                        label="IRPEF"
                        value={state.traspSimulazioniSrl.I100}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K100"
                        label="Add. Reg."
                        value={state.traspSimulazioniSrl.K100}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M100"
                        label="Add. Com."
                        value={state.traspSimulazioniSrl.M100}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H86"
                        label="Contr. ivs"
                        value={state.traspSimulazioniSrl.H86}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N73"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N73}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="H77"
                        label="Totale IRPEF"
                        value={state.riepilogoSimulazioniSrl.H77}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I77"
                        label="Totale Add. reg."
                        value={state.riepilogoSimulazioniSrl.I77}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="J77"
                        label="Totale Add. com."
                        value={state.riepilogoSimulazioniSrl.J77}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="L77"
                        label="Totale Contr. ivs"
                        value={state.riepilogoSimulazioniSrl.L77}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="N77"
                        label="Generale"
                        value={state.riepilogoSimulazioniSrl.N77}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N78"
                        label="Imposte"
                        value={state.riepilogoSimulazioniSrl.N78}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N79"
                        label="Contributi"
                        value={state.riepilogoSimulazioniSrl.N79}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </Paper>
            <SectionTitle primary={false} text={"6° Simulazione - società trasparente - compensi " + state.datiSimulazioniSrl.D102}></SectionTitle>
            <Paper className={gClasses.mainPaper}>
                <div>
                    <TextField
                        name="G48"
                        label="Società"
                        value={state.datiSimulazioniSrl.G48}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I8"
                        label="Contr. g.s."
                        value={state.traspCompSimulazioniSrl.I8}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I8"
                        label="Totale"
                        value={state.traspCompSimulazioniSrl.I8}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C52"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C52}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G104"
                        label="Comp."
                        value={state.datiSimulazioniSrl.G104}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="D25"
                        label="Contr. g.s."
                        value={state.traspCompSimulazioniSrl.D25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I36"
                        label="IRPEF"
                        value={state.traspCompSimulazioniSrl.I36}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K36"
                        label="Add. Reg."
                        value={state.traspCompSimulazioniSrl.K36}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M36"
                        label="Add. Com."
                        value={state.traspCompSimulazioniSrl.M36}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H22"
                        label="Contr. IVS"
                        value={state.traspCompSimulazioniSrl.H22}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N87"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N87}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C53"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C53}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G105"
                        label="Comp."
                        value={state.datiSimulazioniSrl.G105}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="D56"
                        label="Contr. g.s."
                        value={state.traspCompSimulazioniSrl.D56}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I67"
                        label="IRPEF"
                        value={state.traspCompSimulazioniSrl.I67}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K67"
                        label="Add. Reg."
                        value={state.traspCompSimulazioniSrl.K67}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M36"
                        label="Add. Com."
                        value={state.traspCompSimulazioniSrl.M67}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H53"
                        label="Contr. IVS"
                        value={state.traspCompSimulazioniSrl.H53}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N88"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N88}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <TextField
                        name="C54"
                        label="Socio"
                        value={state.datiSimulazioniSrl.C54}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                            disabled: true
                        }}
                        margin="normal"
                    />
                    <NumberField style={{margin: "0px"}}
                        name="G106"
                        label="Comp."
                        value={state.datiSimulazioniSrl.G106}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="D87"
                        label="Contr. g.s."
                        value={state.traspCompSimulazioniSrl.D87}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I98"
                        label="IRPEF"
                        value={state.traspCompSimulazioniSrl.I98}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="K98"
                        label="Add. Reg."
                        value={state.traspCompSimulazioniSrl.K98}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="M36"
                        label="Add. Com."
                        value={state.traspCompSimulazioniSrl.M98}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H53"
                        label="Contr. IVS"
                        value={state.traspCompSimulazioniSrl.H84}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N89"
                        label="Totale"
                        value={state.riepilogoSimulazioniSrl.N89}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="G93"
                        label="Totale Contr. g.s."
                        value={state.riepilogoSimulazioniSrl.G93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="H93"
                        label="Totale IRPEF"
                        value={state.riepilogoSimulazioniSrl.H93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="I93"
                        label="Totale Add. Reg."
                        value={state.riepilogoSimulazioniSrl.I93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="J93"
                        label="Totale Add. Com."
                        value={state.riepilogoSimulazioniSrl.J93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="L93"
                        label="Totale Contr. IVS"
                        value={state.riepilogoSimulazioniSrl.L93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
                <div>
                    <NumberField style={{margin: "0px"}}
                        name="N93"
                        label="Generale"
                        value={state.riepilogoSimulazioniSrl.N93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N94"
                        label="Imposte"
                        value={state.riepilogoSimulazioniSrl.N94}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField style={{margin: "0px"}}
                        name="N95"
                        label="Contributi"
                        value={state.riepilogoSimulazioniSrl.N95}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </Paper>
        </React.Fragment >
    )
}
*/